import { Table } from "flowbite-react";
import React, { useState, useEffect } from "react";
import axios from "axios";

function CSingleBoxingQuantity({ orderid }) {
    const [completedQuantiy, setcompletedQuantiy] = useState({ boxings: [] });
    const url = localStorage.getItem("url");

    useEffect(() => {
        if (orderid) {
            fetchCompletedQuantity();
        }
    }, [orderid]);

    const fetchCompletedQuantity = async () => {
        // console.log("Fetching orderid:", orderid);
        try {
            const response = await axios.get(`single_boxing/completed_qunatity/${orderid}`);
            setcompletedQuantiy(response.data);
        } catch (error) {
            console.error("Error fetching completed quantity:", error);
        }
    };

    // Safe total calculation
    const totalPieces = completedQuantiy.boxings?.reduce(
        (sum, item) => sum + item.total_piece,
        0
    ) || 0;

    return (
        <div className="overflow-x-auto p-2">
            <Table hoverable>
                <Table.Head>
                    <Table.HeadCell>Color</Table.HeadCell>
                    <Table.HeadCell>Size Variant</Table.HeadCell>
                    <Table.HeadCell>Total</Table.HeadCell>
                </Table.Head>
                <Table.Body className="divide-y">
                    {completedQuantiy.boxings?.map((item, index) => (
                        <Table.Row key={index} className="bg-white">
                            <Table.Cell
                                className="font-semibold "
                            >

                                <div className="flex items-center space-x-2">
                                    <div className="flex items-center justify-center">
                                        <img
                                            src={`${url}${item.color_image}`}
                                            alt={item.color}
                                            className="w-[25px] h-[25px] object-cover rounded-lg drop-shadow-md"
                                        />
                                    </div>
                                    <span>{item.color}</span>
                                </div>
                            </Table.Cell>
                            <Table.Cell>{item.formatted_size_variant}</Table.Cell>
                            <Table.Cell>{item.total_piece}</Table.Cell>
                        </Table.Row>
                    ))}
                    <Table.Row className="bg-gray-100 font-bold">
                        <Table.Cell colSpan="2" className="text-right">Total:</Table.Cell>
                        <Table.Cell>{totalPieces}</Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        </div>
    );
}

export default CSingleBoxingQuantity;
